import React from 'react';
import 'twin.macro';
import { useTranslation } from 'react-i18next';
import HandHeartSticker from 'assets/hand-heart-sticker.png';

interface Props {
  parrain: string;
  className?: string;
}

export function Parrain(props: Props) {
  const { parrain, className } = props;
  const { t } = useTranslation(['auth', 'common']);
  return (
    <div className={className}>
      <div tw="mb-4 text-3xl font-bold text-balance">
        <img src={HandHeartSticker} />
        {t('auth:XWantToReferYou', {
          parrain,
        })}
      </div>
      <div>{t('auth:XWantToReferYouDescription')}</div>
    </div>
  );
}
